import { dayjs } from 'utils/providers/Timezone';
import { Logs } from 'utils/types';

export interface LOG_TRANSFORMER {
  date: number;
  logs: Logs[];
}

interface MORPH_LOG_RESPONSE {
  meta: any;
  data: LOG_TRANSFORMER[];
}

const logsTransformer = ({
  data,
  meta,
}: {
  data: Logs[];
  meta: any;
}): MORPH_LOG_RESPONSE => {
  const values: LOG_TRANSFORMER[] = [];

  data.forEach((d) => {
    const month = dayjs(d.createdAt).startOf('month').unix();

    const index = values.map(({ date }) => date).indexOf(month);

    if (index < 0) {
      values.push({
        date: dayjs(d.createdAt).startOf('month').unix(),
        logs: [d],
      });
    } else {
      const index = values.map(({ date }) => date).indexOf(month);

      values[index] = {
        ...values[index],
        logs: [...values[index].logs, d],
      };
    }
  });

  return {
    meta,
    data: values,
  };
};

export default logsTransformer;
